import { tierWorkGroupAPI } from "@/views/TierWorkGroup/services/api";

export const getWorkGroups = async () => {
  try {
    const res = await tierWorkGroupAPI.getWorkGroups();
    return res?.data;
  } catch (e) {}
};

export const getWorkGroup = async (work_group_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.getWorkGroup(work_group_dict_id);
    return res?.data;
  } catch (e) {}
};

export const saveWorkGroup = async (data) => {
  try {
    const res = await tierWorkGroupAPI.saveWorkGroup(data);
    return res;
  } catch (e) {}
};

export const deleteWorkGroup = async (work_group_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.deleteWorkGroup(work_group_dict_id);
    return res;
  } catch (e) {}
};

export const getTasks = async (work_group_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.getTasks(work_group_dict_id);
    return res?.data;
  } catch (e) {}
};

export const getTask = async (task_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.getTask(task_dict_id);
    return res?.data;
  } catch (e) {}
};

export const saveTask = async (data) => {
  try {
    const res = await tierWorkGroupAPI.saveTask(data);
    return res;
  } catch (e) {}
};

export const deleteTask = async (task_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.deleteTask(task_dict_id);
    return res;
  } catch (e) {}
};

export const getUnits = async () => {
  try {
    const res = await tierWorkGroupAPI.getUnits();
    return res?.data;
  } catch (e) {}
};

// Сервисы для работы с задачами конкретной group работ (work_group_task_tab)
export const getWorkGroupTasks = async (work_group_id) => {
  try {
    const res = await tierWorkGroupAPI.getWorkGroupTasks(work_group_id);
    return res?.data;
  } catch (e) {}
};

export const addWorkGroupTask = async (work_group_id, task_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.addWorkGroupTask(work_group_id, task_dict_id);
    return res;
  } catch (e) {}
};

export const deleteWorkGroupTask = async (work_group_id, task_dict_id) => {
  try {
    const res = await tierWorkGroupAPI.deleteWorkGroupTask(work_group_id, task_dict_id);
    return res;
  } catch (e) {}
};

export const addWorkGroupTasksBulk = async (work_group_id, task_dict_ids) => {
  try {
    const res = await tierWorkGroupAPI.addWorkGroupTasksBulk(work_group_id, task_dict_ids);
    return res;
  } catch (e) {}
};

